export default function Hero() {
  return (
    <section className="hero" id="home">
      <div className="container">
        <h1>Digital Transformation for  {/* Palghar-Boisar */} Industries</h1>
        <p>
          Professional Websites, Business Emails & AI Chatbots tailored for
          Chemical, Manufacturing and Engineering businesses. Generate more
          leads, 24/7.
        </p>

        <div className="hero-btns">
          <a href="#solutions" className="btn">View Solutions</a>
          <a href="#contact" className="btn btn-accent">
            Get Free Consultation
          </a>
        </div>
      </div>
    </section>
  );
}
